<template>
  <div class="admin-entity-content--container">
    <div class="content">
      <div class="toolbar">
        <div class="row">
          <h1 class="heading">
            <iconComponent symbol="folder" /> Campaigns
          </h1>
          <div class="actions">
            <button class="button-yellow">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                <path d="M8.9356 2.60246L8.93555 2.60193L8.92309 2.60419C8.90038 2.60832 8.87925 2.61402 8.86246 2.61897C8.61423 2.67782 8.43868 2.90188 8.44406 3.15842V14.3908L5.0939 11.0406C4.99152 10.9328 4.85186 10.8746 4.70626 10.8725L4.70626 10.8725L4.70267 10.8725C4.48275 10.8746 4.28553 11.0081 4.20295 11.2135L4.20294 11.2135L4.20265 11.2143C4.12258 11.4165 4.1702 11.6509 4.32898 11.8044L8.59828 16.0859L8.59825 16.086L8.60082 16.0884L8.88305 16.3584L8.98673 16.4576L9.09042 16.3584L9.37265 16.0884L9.37268 16.0885L9.37519 16.0859L13.6405 11.8083C13.7961 11.6775 13.8681 11.4709 13.822 11.2697L13.822 11.2694C13.7753 11.0678 13.6167 10.9092 13.4152 10.8626L13.4148 10.8625C13.2136 10.8164 13.0069 10.8885 12.8761 11.0441L9.52941 14.3908V3.15951C9.5348 3.00271 9.47091 2.85348 9.35963 2.7485V2.7485C9.2455 2.64075 9.09085 2.58757 8.9356 2.60246Z" fill="#EA7801" stroke="#EA7801" stroke-width="0.3"/>
              </svg>
              Export all
            </button>
            <button @click="showCollectionWizard = true;" class="button-solid">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
                <path d="M11.9649 0.5L11.597 1.46562L10.7118 3.79921L8.47022 2.66116L7.52759 2.18984L7.96442 3.14397L9.01051 5.42008L6.60794 6.21327L5.61933 6.53515L6.58495 6.903L8.60816 7.6847L6.15962 10.1562C6.13232 10.1835 6.10933 10.2137 6.09065 10.2482L0.354385 15.973L0.34289 15.9845C-0.111183 16.4888 -0.121242 17.2676 0.354385 17.7433L0.768224 18.1571C1.27259 18.6112 2.05141 18.6212 2.52704 18.1456L8.34377 12.3404L8.93004 11.7426L10.6889 9.9838L11.3326 11.9036L11.6545 12.8577L12.0223 11.915L12.942 9.56996L15.1606 10.6735L16.0802 11.1334L14.6548 7.9261L17.0229 7.1674L18 6.84552L17.0459 6.47767L14.7008 5.55803L15.8388 3.33939L16.3102 2.40826L15.356 2.83359L13.0799 3.85669L12.2867 1.47712L11.9649 0.5ZM11.9189 2.68415L12.5166 4.46595L12.6431 4.8568L13.0109 4.68437L14.7123 3.93716L13.8616 5.58102L13.6777 5.93738L14.057 6.08682L15.8159 6.77655L14.034 7.35133L13.6432 7.47778L13.8156 7.84563L14.5743 9.55847L12.5511 8.54686L12.4132 8.92621L11.712 10.708L11.2751 9.39753L12.4592 8.21349C12.9348 7.73786 12.9247 6.95904 12.4707 6.45468L12.4477 6.43169L12.0223 6.04084C12.018 6.03653 12.0151 6.03365 12.0108 6.02934C11.7594 5.78506 11.4346 5.67298 11.1372 5.67298C10.8354 5.67298 10.5049 5.78794 10.252 6.04084H10.2405L9.18294 7.10992L7.81497 6.58113L9.63127 5.98336L10.0221 5.85691L9.84968 5.48905L9.06799 3.78772L10.7463 4.63839L11.1142 4.82231L11.2521 4.44296L11.9189 2.68415ZM11.1372 6.40869C11.2766 6.40869 11.3786 6.44318 11.4935 6.55814L11.505 6.56963L11.9304 6.94898C12.1387 7.18033 12.1287 7.50939 11.9419 7.69619L8.66564 10.9609L7.53908 9.83436L10.7693 6.55814C10.8843 6.44318 10.9978 6.40869 11.1372 6.40869ZM7.02178 10.3517L8.14834 11.4782L7.81497 11.8116C7.79773 11.8288 7.78192 11.8489 7.76899 11.8691L2.00974 17.6283C1.82581 17.8122 1.50537 17.8252 1.27403 17.6283L1.26253 17.6168L0.929161 17.272L0.871684 17.226C0.687755 17.042 0.674823 16.7216 0.871684 16.4903L6.61944 10.7425C6.63094 10.7353 6.64243 10.7281 6.65393 10.7195L7.02178 10.3517ZM14.7008 12.7197L14.3559 13.5934L13.8961 14.7659L12.7236 15.2258L11.8499 15.5706L12.7236 15.9155L13.8961 16.3753L14.3559 17.5478L14.7008 18.4215L15.0457 17.5478L15.5055 16.3753L16.678 15.9155L17.5517 15.5706L16.678 15.2258L15.5055 14.7659L15.0457 13.5934L14.7008 12.7197ZM9.98763 12.9956L9.61977 13.9153L8.70013 14.2831L9.61977 14.651L9.98763 15.5706L10.3555 14.651L11.2751 14.2831L10.3555 13.9153L9.98763 12.9956ZM14.7008 14.7544L14.8732 15.1913L14.9307 15.3407L15.0801 15.3982L15.517 15.5706L15.0801 15.7431L14.9307 15.8005L14.8732 15.95L14.7008 16.3868L14.5284 15.95L14.4709 15.8005L14.3214 15.7431L13.8846 15.5706L14.3214 15.3982L14.4709 15.3407L14.5284 15.1913L14.7008 14.7544Z" fill="white"/>
              </svg>
              Start campaign
            </button>
          </div>
        </div>
        <div class="row">
          <div class="filters">
            <button
              class="filter"
              :class="{ 'filter-active': filter === 'all' || filter === '' }"
              @click="setFilter('all')">
              All
            </button>
            <button
              class="filter"
              :class="{ 'filter-active': filter === 'published' }"
              @click="setFilter('published')">
              Published
            </button>
            <button
              class="filter"
              :class="{ 'filter-active': filter === 'draft' }"
              @click="setFilter('draft')">
              Draft
            </button>
            <button
              class="filter"
              :class="{ 'filter-active': filter === 'archived' }"
              @click="setFilter('archived')">
              Archived
            </button>
          </div>
          <div class="search"></div>
        </div>
      </div>

      <div v-if="mappedCollections && !error" class="collections">
        <CampaignCard
          v-for="collection in mappedCollections"
          :key="collection.id"
          :collection="collection"
          :selectedSubcollections="collection.selectedSubcollections"
          :isBookmarked="isBookmarked(collection.data.id)"
          @openCreateActivation="startActivationWizard"
          @editActivation="handleEditActivation"
          @editCollection="handleEditCollection"
          @viewActivation="handleViewActivation"
          @viewCollection="handleViewCollection"
          @addSubcollection="openSubCollectionWizard($event)"
          @selectSubcollectionForId="handleSelectSubcollection"
          @deselectSubcollectionForId="handleDeselectSubcollection"
          @toggleExpandedForId="handleToggleExpanded"
        />

        <p v-if="mappedCollections.length === 0 && !loading" class="result-text">
          0 campaigns
        </p>
      </div>

      <p v-if="error" class="result-text">
        {{ error }}
      </p>
    </div>

    <CampaignWizard
      :data="this.collectionWizard"
      :show="this.showCollectionWizard"
      @close="showCollectionWizard = false"
      @changeData="setCollectionWizardData"
      @createCampaign="createCampaign"
      @disappeared="resetCollectionWizardData"
    />

    <ActivationWizard
      :data="this.activationWizard"
      :show="this.showActivationWizard"
      @close="showActivationWizard = false"
      @changeData="setActivationWizardData"
      @createActivation="createActivation"
      @disappeared="resetActivationWizardData"
    />

    <modal
      v-if="!!this.newCampaign"
      @close="newCampaign = null;"
      :size="{ width: 912 }"
      :padding="'0px'"
      modalType="fullscreen"
    >
      <div class="new-campaign">
        <h1>Successfully added a new campaign!</h1>
        <p>Let's create your first Activation or Sub-Campaign to your campaign</p>
        <button class="button-solid" @click="newCampaign = null;">Done</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import BeforeEnterMixin from "../mixins/BeforeEnterMixin.vue";
import CampaignCard from "../stories/components/CampaignCard/CampaignCard.vue";
import CampaignWizard from "../stories/components/CampaignWizard/CampaignWizard.vue";
import ActivationWizard from "../stories/components/ActivationWizard/ActivationWizard.vue";

export default {
  name: "PartnerCollections",
  components: {
    CampaignCard,
    CampaignWizard,
    ActivationWizard,
},
  mixins: [BeforeEnterMixin],
  watch: {
    $route: {
      handler(router) {
        this.getCollections();
      },
      deep: true
    },
    collectionsById: {
      handler() {
        this.mappedCollections = this.collections.map(collection => ({
          ...this.collectionsById[collection.id],
          selectedSubcollections: this.getSelectedSubcollectionsForId(collection.id)
        }));
      },
      deep: true
    },
    'collectionWizard.background'(image) {


    }
  },
  async mounted() {
    // Note: Make sure the company is loaded before getting the goodiebags
    await this.$store.dispatch('getPickedCompany');
    this.getCollections();
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    companyId() {
      return this.$store.getters.company?._id || null;
    },
    filter() {
      return (this.$route.query.filter || 'all').toLowerCase();
    },
  },
  data() {
    return {
      collectionsById: {},
      collections: null,
      mappedCollections: null,
      loading: false,
      error: null,
      showCollectionWizard: false,
      showActivationWizard: false,

      collectionWizard: {
        name: '',
        info: '',
        theme: null,
        background: null,
        logo: null,
        startPage: null,
      },

      activationWizard: {
        name: '',
        module: null,
        collectionId: null
      },

      newCampaign: null,
    };
  },
  methods: {
    isBookmarked(id) {
      return this.user.bookmarked_goodiebags.some(collection => collection._id === id);
    },
    async createCampaign(data) {
      try {
        if (!data)
          throw new Error('No data');

        const collectionData = {
          company: this.companyId,
          name: data.name,
          uniqueName: data.name.toLowerCase().replace(/ /g, "-"), // ToDo: Replace with sluggification function
          theme: data.theme,
          info: data.info,
          parentGoodiebagId: data.parentGoodiebagId,
          order: 0,
          filenames: "",
          thumbnailFilenames: "",
          thirdPartyCrmName: ""
        };

        let formData = new FormData();
        formData.append('collection', JSON.stringify(collectionData));

        if (data.background !== null)
          formData.append('backgroundImage', data.background.fileObject);

        if (data.logo !== null)
          formData.append('logoImage', data.logo.fileObject);

        if (data.startPage !== null)
          formData.append('startPageImage', data.startPage.fileObject);

        const { data: result } = await axios.post(`/api/c/companies/collections`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        this.showCollectionWizard = false; // Close collectionWizard
        this.newCampaign = result; // Place result in property to signal success
        this.getCollections(); // ToDo: Consider inserting result into existing data rather than fetching it all again

      } catch (error) {
        console.log('Error', error);
      }
    },
    async createActivation(data) {
      try {
        if (!data)
          throw new Error('No data');

        const { data: result } = await axios.post(`/api/c/companies/collections/${data.collectionId}/activations`, JSON.stringify({
          name: data.name,
          template: data.module
        }), {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (result?.offer?._id) {
          this.$router.push({ name: 'PartnerActivation', params: { activationId: result.offer._id } });
        }

      } catch (error) {
        console.log('Error', error);
      }

    },
    async getCollections() {
      if (!this.companyId) {
        this.error = 'No company id';
        return;
      }

      this.loading = true;
      this.error = null;
      try {
        const { data } = await axios.get(`/api/c/companies/collections`, {
          params: {
            state: this.filter,
            // query: ''
          },
        });
        this.setCollections(data.collections);
      } catch (error) {
        console.log('Error', error);
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    },
    setCollectionWizardData(newData) {
      this.collectionWizard = {
        ...this.collectionWizard,
        ...newData,
      };
    },
    openSubCollectionWizard(data) {
      console.log('openSubCollectionWizard', data);
      this.setCollectionWizardData(data);
      this.showCollectionWizard = true;
    },
    resetCollectionWizardData() {
      this.collectionWizard = { name: '', info: '', theme: null, background: null, logo: null };
    },
    setActivationWizardData(newData) {
      this.activationWizard = {
        ...this.activationWizard,
        ...newData,
      };
    },
    resetActivationWizardData() {
      this.activationWizard = { name: '', module: null, collectionId: null };
    },
    getSelectedSubcollectionsForId(id) {
      return this.collectionsById[id].selectedSubcollectionIds.map(selectedId => this.collectionsById[selectedId]);
    },
    mapCollection(collection) {
      return {
        data: collection,
        loading: false,
        showActivations: false,
        selectedSubcollectionIds: []
      }
    },
    setCollections(data) {
      this.collections = data;
      this.collectionsById = data.reduce(
        (result, collection) => ({
          ...result,
          [collection.id]: this.mapCollection(collection),
        }),
        {}
      );
    },
    setFilter(filter) {
      this.$router.push({ query: { filter } });
    },
    async handleSelectSubcollection(id, subcollection) {
      try {
        this.collectionsById[id].loading = true;

        // Only fetch subcollection data if not available
        if (!this.collectionsById[subcollection.id]) {
          const { data } = await axios.get(`/api/c/companies/${this.companyId}/collections/${subcollection.id}`);
          this.collectionsById[subcollection.id] = this.mapCollection(data);
        }

        this.collectionsById[id].selectedSubcollectionIds.push(subcollection.id);
      } catch (error) {
        console.error(error);
      } finally {
        this.collectionsById[id].loading = false;
      }
    },
    handleDeselectSubcollection(id) {
      this.collectionsById[id].selectedSubcollectionIds = this.collectionsById[id].selectedSubcollectionIds.slice(0, -1);
    },
    handleToggleExpanded(id, isExpanded) {
      this.collectionsById[id].showActivations = isExpanded;
    },
    handleViewCollection(id) {
      this.$router.push({ name: 'PartnerDashboardCollection', params: { collectionId: id } });
    },
    handleEditCollection(id) {
      this.$router.push({ name: 'PartnerCollection', params: { collectionId: id } });
    },
    handleViewActivation(id) {
      this.$router.push({ name: 'PartnerDashboardActivation', params: { activationId: id } });
    },
    handleEditActivation(id) {
      this.$router.push({ name: 'PartnerActivation', params: { activationId: id } });
    },
    startActivationWizard(collectionId) {
      if (!collectionId)
        throw new Error('No collection id');

      this.activationWizard = {
        name: '',
        module: null,
        collectionId,
      }
      this.showActivationWizard = true;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/pages/CompanyCollections";
</style>
